import React from 'react';
import ContactPage from '../components/landing/ContactPage';

const Contact = () => {
  return <ContactPage />;
};

export default Contact;
